export const authController = 'auth'

export const designController = 'designs/'

export const simConfigController = 'sim/config'

export const cartController = 'cart/'

export const paymentController = 'payments/'

export const nonConfigurablesController = 'nonconfigurables/'

export const PER_PAGE_DEFAULT = 5

export const INITIAL_PAGE = 1
